export const truncateText = ({ content, length = 50 }: { content?: string; length?: number }): string =>
  content && content?.length > length ? `${content?.slice(0, length)}...` : content || '';
